import { ref } from 'vue';

// Module singleton (same pattern as useResults/useView). The map viewport bbox
// is request state, not shareable filter state: it feeds the API call but never
// the page URL (criteriaContract). Shape: [longMin, latMin, longMax, latMax].
const bbox = ref(null);

// Bumped when something outside the map asks it to re-frame its results
// ("Filters wissen" must bring the map back to all results, WHN-2127). A
// counter rather than a boolean, so two requests in a row both register. The map
// stays the owner of its camera: this is a request, not a command.
const fitRequest = ref(0);

export const useMapState = () => ({
  bbox,
  fitRequest,
  setBbox: (value) => {
    bbox.value = value;
  },
  clearBbox: () => {
    bbox.value = null;
  },
  requestFit: () => {
    fitRequest.value += 1;
  }
});
